<template>
	<div>
		<div style="border-top: 1px solid #bbbbbb"></div>
		<div class="w_1200">
			<div class="f18 font_w m_10" style="margin: 20px 0">
				{{name}}
			</div>
			<div class="m_10">
				<el-row :gutter="20">
					<el-col :xs="24" :sm="24" :md="12" :lg="10" :xl="10">
						<div class="product-image-viewer">
							<!-- 大图展示区域 -->
							<div class="main-image">
								<img :src="currentImage" alt="商品大图" />
							</div>
							<!-- 小图导航区域 -->
							<div class="thumbnail-nav">
								<button @click="prevThumbnail" :disabled="currentThumbnailIndex === 0">
									&lt;
								</button>
								<div class="thumbnail-container" ref="thumbnailContainer">
									<div class="thumbnails" ref="thumbnails" @click="handleThumbnailAreaClick($event)">
										<img v-for="(image, index) in images" :key="index" :src="image"
											:class="{ active: index === currentThumbnailIndex }"
											@click="changeImage(index)" class="thumbnail" />
									</div>
								</div>
								<button @click="nextThumbnail" :disabled="currentThumbnailIndex === images.length - 1">
									&gt;
								</button>
							</div>
						</div>
					</el-col>
					<el-col :xs="24" :sm="24" :md="12" :lg="14" :xl="14">
						<div class="box_js flex">
							<div class="f18" style="margin-right: 20px">
								{{$t('goods.price')}}{{price_ext == '' ? '' : ':(' + price_ext + ')'}}
							</div>
							<div class="num_28 red">${{price}}</div>
						</div>
						<div class="box_js top_up" style="height: 370px">
							<div class="f18">{{$t('goods.param_title')}}</div>
							<div class="flex f16" style="margin-top: 20px" v-for="(item,index) in params" :key="index">
								<div style="margin-right: 5em; color: #999999">{{item.label}}</div>
								<div>{{item.value}}</div>
							</div>
						</div>
						<div class="box_js flex_js top_up" style="height: 55px">
							<div class="f14" style="color: #999999; width: 60%">
								{{$t('goods.seek_tip')}}
							</div>
							<div class="flex">
								<el-button icon="el-icon-star-off" v-if="order_id==''"
									@click="submitSeek">{{$t('goods.btn_submit_seek')}}</el-button>
								<el-button type="primary" v-else icon="el-icon-star-on"
									@click="cancelSeek">{{$t('goods.btn_cancel_seek')}}</el-button>
							</div>
						</div>
					</el-col>
				</el-row>
				<div style="margin-top: 20px;" ref="richText" class="img_fix" v-html="content">
				</div>
				<!-- <div style="margin-top: 20px">
					<p>
					<img src="https://img0.baidu.com/it/u=635924263,460252741&fm=253&app=120&f=JPEG?w=800&h=800"
						style="width: 100%" alt="" />
						</p>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getInfo,
		toSeek
	} from "@/api/goods"
	import {
		getToken
	} from "@/utils/auth";
	export default {
		data() {
			return {
				id: '',
				name: '',
				price: '',
				price_ext: '',
				content: '',
				params: [],
				images: [],
				currentImage: "",
				order_id: "",
				currentThumbnailIndex: 0,
				thumbnailWidth: 100,
				visibleThumbnails: 4,
			};
		},
		mounted() {
			// this.currentImage = this.images[0];
			var id = this.$route.query.id //this.getQueryParams('id');
			console.log(id);
			this.init(id)

		},
		methods: {
			init(id) {
				this.id = id // '1945766276005629952'
				getInfo({
					id: this.id
				}).then(res => {
					if (res.code == 200) {
						this.name = res.data.name
						this.price = res.data.price
						this.price_ext = res.data.price_ext
						this.params = res.data.params
						this.content = res.data.content
						this.order_id = res.data.order_id
						this.images = res.data.banners
						this.currentImage = this.images[0]

						this.$nextTick(() => {
							const images = this.$refs.richText.querySelectorAll('img')
							console.log(images)
							images.forEach(img => {
								img.style.width = '100%'
								img.style.height = 'auto'
							})
						})
					}
				})
			},
			getQueryParams(param) {
				console.log('gqp')
				console.log(window.location.search)
				const searchParams = new URLSearchParams(window.location.search);
				console.log(searchParams)
				return searchParams.get(param);
			},
			submitSeek() {
				var token = getToken()
				console.log('token', token)
				if (token == null) {
					this.$router.push({
						path: '/login'
					}, () => {})
					return
				}
				toSeek({
					goods_id: this.id
				}).then(res => {
					if (res.code == 200) {
						this.order_id = res.data.order_id
						this.$modal.msgSuccess(res.msg)
					} else {
						this.$modal.msgError(res.msg)
					}
				})
			},
			cancelSeek() {
				toSeek({
					order_id: this.order_id
				}).then(res => {
					if (res.code == 200) {
						this.order_id = ''
						this.$modal.msgSuccess(res.msg)
					} else {
						this.$modal.msgError(res.msg)
					}
				})
			},
			// 切换大图
			changeImage(index) {
				this.currentImage = this.images[index];
				this.currentThumbnailIndex = index;
				this.scrollToThumbnail(index);
			},
			// 上一个小图
			prevThumbnail() {
				if (this.currentThumbnailIndex > 0) {
					this.currentThumbnailIndex--;
					this.currentImage = this.images[this.currentThumbnailIndex];
					this.scrollToThumbnail(this.currentThumbnailIndex);
				}
			},
			// 下一个小图
			nextThumbnail() {
				if (this.currentThumbnailIndex < this.images.length - 1) {
					this.currentThumbnailIndex++;
					this.currentImage = this.images[this.currentThumbnailIndex];
					this.scrollToThumbnail(this.currentThumbnailIndex);
				}
			},
			// 滚动到指定小图
			scrollToThumbnail(index) {
				const container = this.$refs.thumbnailContainer;
				const thumbnails = this.$refs.thumbnails;
				const scrollLeft =
					index * this.thumbnailWidth -
					(container.offsetWidth / 2 - this.thumbnailWidth / 2);
				thumbnails.scrollTo({
					left: scrollLeft,
					behavior: "smooth",
				});
			},
		},
	};
</script>

<style scoped>
	.img_fix img {
		max-width: 100% !important;
	}

	img {
		width: 100% !important;
	}

	.num_28 {
		font-size: 28px;
	}

	.box_js {
		padding: 20px 15px;
		background-color: rgba(242, 242, 242, 1);
	}

	.product-image-viewer {
		max-width: 800px;
		margin: 0 auto;
	}

	.main-image img {
		width: 100%;
		height: 500px;
	}

	@media (max-width: 768px) {
		.main-image img {
			width: 100%;
			height: 366px;
		}

		.num_28 {
			font-size: 18px;
		}

		.thumbnail {
			width: 80px !important;
			height: 80px !important;
			object-fit: cover;
			margin-right: 10px;
			cursor: pointer;
			border: 2px solid transparent;
		}
	}

	.thumbnail-nav {
		display: flex;
		align-items: center;
	}

	.thumbnail-nav button {
		padding: 10px;
		background-color: #f0f0f0;
		border: none;
		cursor: pointer;
	}

	.thumbnail-nav button:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	.thumbnail-container {
		flex: 1;
		overflow-x: auto;
		margin: 0 10px;
	}

	.thumbnails {
		display: flex;
		transition: transform 0.3s ease;
	}
	.thumbnail {
		width: 100px !important;
		height: 100px !important;
		object-fit: cover;
		margin-right: 10px;
		cursor: pointer;
		border: 2px solid transparent;
	}

	.thumbnail.active {
		border-color: #007bff;
	}
</style>